import React from 'react';
import ForgotPasswordForm from '../../components/ForgotPasswordForm';

function ForgotPasswordPage() {
    return (
        <div className="forgot-password-page">
            <ForgotPasswordForm />
        </div>
    );
}

export default ForgotPasswordPage;